import React, { Component } from 'react';
import { string, shape, bool, number } from 'prop-types';
import GrabMaps, { Marker as GrabMarker } from '@geo/grab-maps';
import { isEmpty } from 'common/utils/data-utils';
import { FIELD_NAME } from 'constants/booking-constants';
import { getMapTilesURL } from 'constants/app-constants';
import NumberedPin from '../../v2/common/numbered-pin';
import css from './map.less';

const GrabMap = GrabMaps({
  dragRotate: false,
});

export default class Map extends Component {
  static propTypes = {
    id: string,
    latlng: shape({}),
    isSender: bool,
    displayPinIndex: number,
    showPinIndex: bool,
  };

  static defaultProps = {
    id: null,
    latlng: {},
    isSender: false,
    displayPinIndex: 0,
    showPinIndex: false,
  };

  renderMap = () => {
    const { id, latlng, isSender, showPinIndex, displayPinIndex } = this.props;
    const isSenderMap = id === FIELD_NAME.SENDER_MAP || isSender;

    if (isEmpty(latlng)) {
      return (
        <div className={css.mapPlaceholder}>
          <NumberedPin
            isSender={isSenderMap}
            showNumber={showPinIndex}
            number={`${displayPinIndex}`}
          />
        </div>
      );
    }

    return (
      <div className={css.staticMap}>
        <GrabMap
          mapStyle={getMapTilesURL()}
          center={[latlng.longitude, latlng.latitude]}
          id="map-canvas"
          zoom={12}
          fitBoundsOptions={{
            offset: [30, 30],
          }}
        >
          <GrabMarker
            coordinates={[latlng.longitude, latlng.latitude]}
            anchor="bottom"
          >
            <NumberedPin
              isSender={isSenderMap}
              showNumber={showPinIndex}
              number={`${displayPinIndex}`}
            />
          </GrabMarker>
        </GrabMap>
      </div>
    );
  };

  render() {
    return this.renderMap();
  }
}
